import script from "./SfxProgressIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxProgressIndicator.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress,QChip,QIcon});
